'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CloseCircleOutlined = _interopRequireDefault(require('./lib/icons/CloseCircleOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CloseCircleOutlined;
exports.default = _default;
module.exports = _default;